import { OwnerNotificationsPostRequest } from '../post'

export class OwnerNotificationsDraftPostRequest extends OwnerNotificationsPostRequest {}
